import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Observable} from 'rxjs';
import {BZ_DIALOG_DATA, BzDialogRef} from '@bringoz/ui';
import {TermsHttpService} from '../../services/terms-http.service';
import {TermsPayload, TermsVersion} from '../../models/terms-version.model';
import {TERMS_EDITOR_FORMATS, TERMS_EDITOR_MODULES} from '../../constants/terms-editor.constant';

export interface TermsEditorDialogData {
  // Omitted when creating a new version.
  version?: TermsVersion;
  readOnly?: boolean;
}

require('./terms-editor-dialog.scss');
@Component({
  standalone: false,
  selector: 'app-terms-editor-dialog',
  templateUrl: './terms-editor-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TermsEditorDialogComponent {

  public readonly editorModules = TERMS_EDITOR_MODULES;
  public readonly editorFormats = TERMS_EDITOR_FORMATS;
  public readonly isReadOnly: boolean;
  public readonly heading: string;

  public readonly form = new FormGroup({
    title: new FormControl<string>('', {nonNullable: true, validators: [Validators.required]}),
    content: new FormControl<string>('', {nonNullable: true, validators: [Validators.required]})
  });

  public isSaving = false;

  constructor(@Inject(BZ_DIALOG_DATA) public data: TermsEditorDialogData,
              @Inject(BzDialogRef) private dialogRef: BzDialogRef<TermsVersion>,
              @Inject(TermsHttpService) private termsHttpService: TermsHttpService,
              @Inject('bringozToastService') private bringozToastService: any,
              @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef) {
    const version = data.version;
    this.isReadOnly = !!data.readOnly;
    this.heading = !version ? 'Create New Policy' : (this.isReadOnly ? version.title : 'Edit Policy');

    if (version) {
      this.form.setValue({title: version.title, content: version.content});
    }
    if (this.isReadOnly) {
      this.form.disable();
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSubmit() {
    if (this.form.invalid || this.isSaving) {
      this.form.markAllAsTouched();
      return;
    }

    const payload: TermsPayload = this.form.getRawValue();
    const request$: Observable<TermsVersion> = this.data.version
      ? this.termsHttpService.update(this.data.version.id, payload)
      : this.termsHttpService.create(payload);

    this.isSaving = true;
    request$.subscribe({
      next: (saved) => this.dialogRef.close(saved),
      error: (err: HttpErrorResponse) => {
        this.isSaving = false;
        this.cdr.markForCheck();
        const moreInfo: string = err?.error?.more_info;
        this.bringozToastService.error({
          body: this.data.version ? 'TERMS_UPDATE_ERROR' : 'TERMS_CREATE_ERROR',
          message: moreInfo,
          details: moreInfo ? undefined : 'SOMETHING_WENT_WRONG'
        });
      }
    });
  }

}
